import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Table(theme: Theme) {
  return {
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: 'none',
          [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1.25, 1.5),
          },
        },
        sizeSmall: {
          [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0.75, 1),
          },
        },
        head: {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.neutral,
          // Keep column titles on one line so narrow screens scroll the table instead of squashing it.
          whiteSpace: 'nowrap',
          '&:first-of-type': {
            paddingLeft: theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
              paddingLeft: theme.spacing(3),
            },
            borderTopLeftRadius: theme.shape.borderRadius,
            borderBottomLeftRadius: theme.shape.borderRadius,
            boxShadow: `inset 8px 0 0 ${theme.palette.background.paper}`,
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
              paddingRight: theme.spacing(3),
            },
            borderTopRightRadius: theme.shape.borderRadius,
            borderBottomRightRadius: theme.shape.borderRadius,
            boxShadow: `inset -8px 0 0 ${theme.palette.background.paper}`,
          },
        },
        stickyHeader: {
          backgroundColor: theme.palette.background.paper,
          backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`,
        },
        body: {
          '&:first-of-type': {
            paddingLeft: theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
              paddingLeft: theme.spacing(3),
            },
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
              paddingRight: theme.spacing(3),
            },
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderTop: `solid 1px ${theme.palette.divider}`,
          overflow: 'hidden',
        },
        toolbar: {
          height: 64,
          // On phones let the pager wrap onto two lines instead of pushing past the card edge.
          [theme.breakpoints.down('sm')]: {
            height: 'auto',
            minHeight: 56,
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
            rowGap: theme.spacing(0.5),
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(1),
          },
        },
        spacer: {
          [theme.breakpoints.down('sm')]: {
            display: 'none',
          },
        },
        selectLabel: {
          [theme.breakpoints.down('sm')]: {
            display: 'none',
          },
        },
        input: {
          [theme.breakpoints.down('sm')]: {
            marginRight: theme.spacing(1),
            marginLeft: 0,
          },
        },
        actions: {
          [theme.breakpoints.down('sm')]: {
            marginLeft: theme.spacing(1),
          },
        },
        select: {
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
        },
        selectIcon: {
          width: 20,
          height: 20,
          marginTop: -4,
        },
      },
    },
  };
}
